import React from "react";
import PropTypes from "prop-types";
import ChatBubble from "./ChatBubble";
import ChatNotification from "./ChatNotification";
import RichChatBubble from "./RichChatBubble";
import ChatIcon from "./ChatIcon";
import AdvisorIcon from "./AdvisorIcon";

const ChatLine = props => {
  if (props.message.source === "_chat-notification") {
    return /*#__PURE__*/React.createElement(ChatNotification, {
      message: props.message.message,
      key: 0
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: `chat-line ${props.message.source === "dpd" || props.message.source === "advisor" ? "receiver-line" : "sender-line"}`
  }, props.message.source === "dpd" ? /*#__PURE__*/React.createElement(ChatIcon, null) : "", props.message.source === "advisor" ? /*#__PURE__*/React.createElement(AdvisorIcon, null) : "", /*#__PURE__*/React.createElement("div", {
    className: "chat-block"
  }, props.message.messages.map((msg, id) => {
    if (typeof msg === "undefined") {
      return null;
    }

    if (typeof msg === "string") {
      return /*#__PURE__*/React.createElement(ChatBubble, {
        message: msg,
        key: id
      });
    } else if (msg.type === "delivery-map" || msg.type === "ofd-map" || msg.type === "images") {
      return /*#__PURE__*/React.createElement(RichChatBubble, {
        data: msg,
        key: id
      });
    }

    return null;
  })));
};

ChatLine.propTypes = {
  message: PropTypes.object
};
export default ChatLine;